var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34C26.3888 34 34 26.3888 34 17Z",
    fill: "#1BAF8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4172 10.352C26.1234 10.0584 25.7251 9.89355 25.3097 9.89355C24.8944 9.89355 24.496 10.0584 24.2022 10.352L14.2312 20.323L9.79922 15.892C9.65602 15.7374 9.4831 15.6132 9.29081 15.527C9.09852 15.4407 8.8908 15.3941 8.68009 15.39C8.46938 15.3859 8.26001 15.4243 8.0645 15.503C7.86899 15.5817 7.69136 15.699 7.54223 15.8479C7.39311 15.9969 7.27556 16.1743 7.19661 16.3697C7.11767 16.5651 7.07895 16.7745 7.08278 16.9852C7.0866 17.1959 7.1329 17.4037 7.21888 17.5961C7.30487 17.7885 7.42879 17.9616 7.58322 18.105L13.1252 23.647C13.2707 23.7926 13.4434 23.9081 13.6335 23.9869C13.8236 24.0658 14.0274 24.1063 14.2332 24.1063C14.439 24.1063 14.6428 24.0658 14.8329 23.9869C15.0231 23.9081 15.1958 23.7926 15.3412 23.647L26.4172 12.568C26.7111 12.2741 26.8761 11.8756 26.8761 11.46C26.8761 11.0444 26.7111 10.6458 26.4172 10.352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.75c511149eed9997798853efc0e27dbb.svg";
export { ForwardRef as ReactComponent };